export default __webpack_public_path__ + "media/images/icons/carousel-arrow-93bedd241b7a000ce95ced8fde8a4fd2.svg";